import type { ReportDimension, ReportQuery } from '@super-mega/server/contracts/analytics'
import type { ReportSearch } from '../report-search.ts'
import { currentMonth } from './format.ts'

// 报表结果在离开页面时回收；每次进入、提交或刷新均从服务端重新查询。
export const reportQueryOptions = { staleTime: 0, gcTime: 0, refetchOnMount: 'always' as const }

export function reportScope(search: ReportSearch, dimension: ReportDimension): ReportQuery {
  return {
    dimension,
    month: search.dateFrom ? undefined : (search.month ?? currentMonth()),
    dateFrom: search.dateFrom,
    dateTo: search.dateTo,
    granularity: search.granularity ?? 'day',
    id: search.id,
    orderKind: search.orderKind,
    organizationIds: search.organizationIds,
    customerIds: search.customerIds,
    salespersonIds: search.salespersonIds,
    siteIds: search.siteIds,
    businessIds: search.businessIds,
    subjectIds: search.subjectIds
  }
}
